const { isAssignAllowed } = require("@/simulation/automation/automator.js");


class AssignHandler {

    constructor(visualiser) {
        this.visualiser = visualiser;

        this.draggingResource = null;
        this.draggingClone = null;
        this.workerSizeWidth = null;
        this.workerSizeHeight = null;

        this.validPlace = false;
    }

    //Handles the mouse movement of the pipeline
    mouseMoveSVG(event) {
        this.task = null;
        if (this.draggingClone == null) {
            this.validPlace = false;
            return
        }

        if (!event.srcElement.__data__) {
            this.validPlace = false;
            return;
        }
        if (!event.srcElement.__data__["task"]) {
            this.validPlace = false;
            return;
        }


        if (isAssignAllowed(event.srcElement.__data__["task"], this.draggingResource, true)) {
            var task = event.srcElement.__data__["task"];
            if (task.isReadyToStart() && !task.isFinished()) {
                this.task = task;
                this.validPlace = true;
            }
        } else {
            this.validPlace = false;
        }
    }

    dragMove(event) {
        // Stop if not dragging the clone
        if (this.draggingClone == null) {
            return;
        }

        // Again attempt to disable the cursor
        document.body.style.setProperty("cursor", "none", "important");
        this.draggingClone.style.setProperty("cursor", "none", "important");

        //Colour the clone according to the valid placement
        if (this.validPlace) {
            this.draggingClone.classList.add("valid");
            this.draggingClone.classList.remove("invalid");
        } else {
            this.draggingClone.classList.remove("valid");
            this.draggingClone.classList.add("invalid");
        }

        //Center the clone on the cursor
        this.draggingClone.style.top =
            (
                event.clientY +
                window.scrollY -
                this.workerSizeWidth
            ).toString() + "px";
        this.draggingClone.style.left =
            (event.clientX - this.workerSizeHeight).toString() + "px";
    }

    startDrag(event, resource, component) {

        if (!this.visualiser.simulator.params.isManual) {
            component.$toast.error("You cannot assign resources in this automatic simulation", { position: "bottom-right", timeout: 5000 });
            return;
        }
        var self = this;
        this.task = null;



        function dragEnd() {
            //Show the cursor again
            document.body.style.setProperty("cursor", "default", "important");

            //Delete the cloned div
            document.body.removeChild(self.draggingClone);
            self.draggingClone = null;

            //Remove the listeners
            document.removeEventListener("mouseup", dragEnd);
            if (self.task != null) {
                self.draggingResource.removeCurrentTask();
                self.draggingResource.setCurrentTask(self.task)
            }

            self.visualiser.updateElements();
        }


        this.draggingResource = resource;

        event.preventDefault();

        //Create a clone to move around
        this.draggingClone = event.target.cloneNode(true);
        this.draggingClone.style.setProperty("cursor", "none", "important");

        this.draggingClone.classList.remove("assignedToTask");
        document.body.appendChild(this.draggingClone);
        this.draggingClone.style.position = "absolute";
        this.draggingClone.style.zIndex = "100";
        this.draggingClone.style.pointerEvents = "none";

        //Attempt to disable the cursor (sometimes doesn't work)
        document.body.style.setProperty("cursor", "none", "important");
        this.draggingClone.style.setProperty("cursor", "none", "important");


        //Store the width and height and resourceID
        this.workerSizeWidth = event.target.offsetWidth / 2;
        this.workerSizeHeight = event.target.offsetHeight / 2;

        //Add listeners
        document.addEventListener("mouseup", dragEnd);

        self.visualiser.updateElements();



        
        return;
    }
}

module.exports = { AssignHandler };
